import { render } from "./MathLevelYearTabs.vue?vue&type=template&id=8ce1649e&ts=true"
import script from "./MathLevelYearTabs.vue?vue&type=script&lang=ts"
export * from "./MathLevelYearTabs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__